import React from 'react';

type Props = {
    children: React.ReactNode
}

function DescriptionTerm(props: Props) {
    return (
        <dt className="text-sm font-medium text-gray-500">
            {props.children}
        </dt>
    );
}

export default DescriptionTerm;